import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fileUrl } from "../lib/api";
import { api } from "../lib/api";
import { Megaphone, ArrowRight } from "lucide-react";

export const SponsorBanner = () => {
  const [sponsor, setSponsor] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/sponsor").then(({ data }) => setSponsor(data)).catch(() => {});
  }, []);

  if (!sponsor || !sponsor.enabled) return null;

  const go = () => {
    const link = sponsor.link || "/supporter";
    if (link.startsWith("http")) window.open(link, "_blank");
    else navigate(link);
  };

  return (
    <div
      data-testid="sponsor-banner"
      onClick={go}
      className="group relative mb-6 cursor-pointer overflow-hidden rounded-xl border border-[#FFB800]/30 bg-gradient-to-r from-[#141B2D] to-[#0F1424] transition-all hover:border-[#FFB800]/60"
    >
      <div className="absolute left-0 top-0 rounded-br-lg bg-[#FFB800] px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-[#090C15]">
        Sponsored
      </div>
      <div className="flex flex-col items-center gap-4 p-5 pt-7 sm:flex-row sm:pt-5">
        {sponsor.image_url ? (
          <img src={fileUrl(sponsor.image_url)} alt="" className="h-16 w-16 shrink-0 rounded-lg object-cover" />
        ) : (
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-[#FFB800]/15 text-[#FFB800]">
            <Megaphone size={22} />
          </span>
        )}
        <div className="min-w-0 flex-1 text-center sm:text-left">
          <h3 className="font-heading text-lg font-bold text-white">{sponsor.title}</h3>
          {sponsor.subtitle && <p className="mt-0.5 text-sm text-[#94A3B8]">{sponsor.subtitle}</p>}
        </div>
        <button className="inline-flex shrink-0 items-center gap-1 rounded-lg bg-[#FFB800] px-4 py-2 text-sm font-bold text-[#090C15] transition-transform group-hover:translate-x-0.5">
          {sponsor.cta || "Learn More"} <ArrowRight size={15} />
        </button>
      </div>
    </div>
  );
};
